<template>
  <div
    :class="[
      stage === 2 ? 'top subsection' : 'top',
      hasActivity ? '' : 'no-bg',
    ]"
  >
    <div class="content">
      <div class="flex">
        <div
          :class="hasActivity ? 'logo' : 'logo logo-s'"
          v-if="Object.keys(logoObj).length > 0"
        >
          <img
            :src="logoObj.logo"
            alt="logo"
            v-if="logoObj.type === 1"
            class="img"
            @click="toHome"
          />
          <h1
            :style="{
              fontSize:
                logoObj.logo && logoObj.logo.length > 9
                  ? '14px'
                  : logoObj.logo && logoObj.logo.length > 5
                  ? '20px'
                  : '',
            }"
            @click="toHome"
            v-else
          >
            {{ logoObj.logo || "网校学习" }}
          </h1>
          <img
            src="https://img2.233.com/wx/union/618/2021/pc/618-logo.png"
            v-if="hasActivity"
          />
        </div>
        <template v-if="hasActivity">
          <div class="step" v-if="stage === 2">
            <div :class="curStep === 1 ? 'one ing' : 'one'">
              <div class="date">
                {{ formatDate(yureModel.StartTime) }}—{{
                  formatDate(yureModel.EndTime)
                }}
              </div>
              <div class="status">
                <span>预热期</span>
                <label v-if="curStep === 1">进行中</label>
                <label v-else>已结束</label>
              </div>
            </div>
            <div :class="curStep === 3 ? 'two ing' : 'two'">
              <div class="date">
                {{ formatDate(zhengshiModel.StartTime) }}—{{
                  formatDate(zhengshiModel.EndTime, 'md')
                }}
              </div>
              <div class="status">
                <span>正式期</span>
                <label v-if="curStep === 3">进行中</label>
                <label v-else>未开始</label>
              </div>
            </div>
          </div>
          <div class="time" v-else>
            <p>
              活动时间：{{ formatDate(zhengshiModel.StartTime) }}—{{
                formatDate(zhengshiModel.EndTime)
              }}
            </p>
            <p>进行中</p>
          </div>
        </template>
      </div>
      <template v-if="hasActivity">
        <div class="count-down">
          <div class="text">
            <p v-if="stage === 1">距活动</p>
            <template v-else>
              <p v-if="curStep === 1">距预热期</p>
              <p v-else>距正式期</p>
            </template>
            <p>{{ stage === 2 && curStep === 2 ? "开始" : "结束" }}仅剩</p>
          </div>
          <div class="num">{{ Math.floor(formatAcitivityDate.day / 10) }}</div>
          <div class="num">{{ formatAcitivityDate.day % 10 }}</div>
          <div class="unit">天</div>
          <div class="num">{{ Math.floor(formatAcitivityDate.hour / 10) }}</div>
          <div class="num">{{ formatAcitivityDate.hour % 10 }}</div>
          <div class="unit">时</div>
          <div class="num">
            {{ Math.floor(formatAcitivityDate.minute / 10) }}
          </div>
          <div class="num">{{ formatAcitivityDate.minute % 10 }}</div>
          <div class="unit">分</div>
          <div class="num">
            {{ Math.floor(formatAcitivityDate.second / 10) }}
          </div>
          <div class="num">{{ formatAcitivityDate.second % 10 }}</div>
          <div class="unit">秒</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { GetUnionLogoByHost } from "../../../lib/request";
export default {
  name: "Top",
  props: {
    curStep: {
      type: Number,
      default: 4,
    },
    hasActivity: {
      type: Boolean,
      default: false,
    },
    stage: {
      type: Number,
      default: 1,
    },
    zhengshiModel: {
      type: Object,
      default: () => {},
    },
    yureModel: {
      type: Object,
      default: () => {},
    },
    activitySurplusTime: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      logoObj: {},
    };
  },
  computed: {
    formatAcitivityDate() {
      const day = Math.floor(this.activitySurplusTime / 1000 / 60 / 60 / 24);
      const hour =
        Math.floor(this.activitySurplusTime / 1000 / 60 / 60) - day * 24;
      const minute =
        Math.floor(this.activitySurplusTime / 1000 / 60) -
        day * 24 * 60 -
        hour * 60;
      const second =
        Math.floor(this.activitySurplusTime / 1000) -
        day * 24 * 60 * 60 -
        hour * 60 * 60 -
        minute * 60;
      return { day, hour, minute, second };
    },
  },
  created() {
    this.GetUnionLogoByHost();
  },
  methods: {
    GetUnionLogoByHost() {
      GetUnionLogoByHost({}, (res) => {
        this.logoObj = res.Result;
      });
    },
    formatDate(time, type = "ymd") {
      const _time = new Date(time);
      let result = null;
      if (type === "ymd") {
        result =
          _time.getFullYear() +
          "年" +
          (_time.getMonth() + 1) +
          "月" +
          _time.getDate() +
          "日";
      } else if (type === "md") {
        result = _time.getMonth() + 1 + "月" + _time.getDate() + "日";
      }
      return result;
    },
    toHome() {
      window.location.href = window.location.origin;
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  position: relative;
  z-index: 3;
  width: 100%;
  height: 70px;
  background: url("https://img2.233.com/wx/union/618/2021/pc/header-bg1.png")
    no-repeat top center;
  .content {
    margin: 0 auto;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    .logo {
      width: 138px;
      height: 133px;
      background: url("https://img2.233.com/wx/union/618/2021/pc/logo-bg.png")
        no-repeat top center;
      background-size: 100% 100%;
      text-align: center;
      z-index: 9;
      h1 {
        height: 44px;
        line-height: 44px;
        color: #d23f40;
        margin: 9px 0;
        font-size: 28px;
        cursor: pointer;
      }
      .img {
        height: 27px;
        margin: 10px 0 14px 0;
        vertical-align: top;
        object-fit: cover;
        cursor: pointer;
      }
    }
    .logo-s {
      width: 181px;
      height: 90px;
      background: url("https://img2.233.com/wx/union/618/2021/pc/logo-bg-s.png")
        no-repeat top center;
      background-size: 100% 100%;
    }
    .time {
      height: 70px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 60px;
      width: 400px;
      margin-right: 115px;
      p {
        color: #fff1cc;
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
      }
    }
    .step {
      display: flex;
      margin-right: 40px;
      margin-top: 13px;
      .one,
      .two {
        position: relative;
        &::after {
          position: absolute;
          background: url('https://img2.233.com/wx/union/618/2021/pc/header-right-icon.png') no-repeat;
          background-size: cover;
          content: ' ';
          width: 14px;
          height: 24px;
          top: 7px;
          right: -50px;
        }
        margin-left: 56px;
        .date {
          height: 20px;
          border-radius: 10px;
          padding: 0 10px;
          font-size: 14px;
          font-weight: 400;
          // background: #B30D11;
          // background: #2a47db;
          // color: #fff;
          color: #778def;
          white-space: nowrap;
        }
        .status {
          text-align: center;
          margin-top: 3px;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            color: #778def;
            font-size: 18px;
            vertical-align: middle;
            font-weight: bold;
          }
          label {
            // color: #c84421;
            color: #0c268b;
            font-size: 14px;
            font-weight: 400;
            background: url("https://img2.233.com/wx/union/618/2021/pc/end-box-icon.png")
              no-repeat center center;
            background-size: 100% 100%;
            display: inline-block;
            height: 20px;
            padding: 0 6px 0 12px;
            margin-left: 6px;
          }
        }
      }
      .two {
        margin-left: 85px;
         &::after {
           right: -40px;
         }
      }
      .ing {
        .date {
          background: linear-gradient(90deg, #fff1cc, #fff2df, #fff1cc);
          // color: #d12221;
          background: #2a47db;
          color: #fff;
        }
        .status {
          span {
            // color: #fff1cc;
            color: #fff;
          }
          label {
            color: #192ea3;
            background: url("https://img2.233.com/wx/union/618/2021/pc/ing-box-icon.png")
              no-repeat center center;
          }
        }
      }
    }
    .count-down {
      margin-top: 11px;
      width: 324px;
      border: 2px solid #3c71f8;
      height: 44px;
      display: flex;
      align-items: center;
      // background: #ac0914;
      border-radius: 5px;
      white-space: nowrap;
      .text {
        margin-left: 12px;
        width: 56px;
        p {
          color: #fff;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
        }
      }
      .num {
        display: inline-block;
        width: 20px;
        height: 30px;
        line-height: 30px;
        background: rgba($color: #659dea, $alpha: 0.3);
        // border-radius: 4px;
        color: #fff;
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        margin-right: 2px;
      }
      .unit {
        font-size: 12px;
        font-weight: 400;
        color: #fff;
        line-height: 12px;
        margin: 0 6px 0 2px;
      }
    }
  }
}
.subsection {
  background: url("https://img2.233.com/wx/union/618/2021/pc/header-bg2.png")
    no-repeat top center;
}
.no-bg {
  background: none;
}
</style>
